import { render, staticRenderFns } from "./taocan.vue?vue&type=template&id=2176bf1d&"
import script from "./taocan.vue?vue&type=script&lang=js&"
export * from "./taocan.vue?vue&type=script&lang=js&"
import style0 from "./taocan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports